<script setup lang="ts">
import { SORT_OPTIONS, type SortOption } from '@@/shared/property/search-criteria';
import { getUrlParamsFromCriteria } from '@@/shared/property/url-serp';

const route = useRoute();
const router = useRouter();
const { locale, t } = useI18n();
const localeRoute = useLocaleRoute();

const { propertySearchCriteria } = usePropertySearchCriteria(route);
interface SelectOption { title: string, value?: SortOption };
const sortOptions = computed<Array<SelectOption>>(() => {
  const SORT_OPTIONS_WITHOUT_PAID_AT = SORT_OPTIONS.filter(option => option !== 'paidAtDesc');
  return SORT_OPTIONS_WITHOUT_PAID_AT.map(option => ({
    title: t(`property_serp.sort.${option}`),
    value: option,
  }));
});
const sort = ref<SelectOption>({
  title: t(`property_serp.sort.${propertySearchCriteria.value.sort}`),
  value: propertySearchCriteria.value.sort,
});

function onSort(selectedOption?: SelectOption) {
  if (!selectedOption) return;
  const updatedCriteria = {
    ...propertySearchCriteria.value,
    sort: selectedOption.value,
  };
  const { serpSlug, query } = getUrlParamsFromCriteria(locale.value, updatedCriteria);
  const translatedRoute = localeRoute(`serp-serpSlug`, locale.value);
  if (!translatedRoute?.name) return;
  const url = {
    name: translatedRoute.name,
    params: { serpSlug },
    query: { ...query, page: undefined },
  };
  // Strangely, need a spread here avoid rendering error
  sort.value = { ...selectedOption };
  router.push(url);
}
</script>

<template>
  <IadSelect
    name="sort"
    :model-value="sort"
    :items="sortOptions"
    @update:model-value="onSort"
  />
</template>
